import type { PolicyViolationOut } from '@repo/api-codegen';
import { Badge } from '@repo/foundations';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';
import { formatPiiClassifierType } from './utils';

export function PiiClassifier({
	violations,
}: {
	violations: PolicyViolationOut[];
}) {
	const dataSamples = useMemo(
		() =>
			violations
				?.map((violation) => violation.data_samples)
				.flat()
				.filter(Boolean)
				.filter((sample) => !isNil(sample)),
		[violations]
	);
	const piiClassifiers = useMemo(() => {
		if (!dataSamples) {
			return [];
		}
		return [
			...new Set(
				dataSamples.map((sample) => formatPiiClassifierType(sample.classifier))
			),
		];
	}, [dataSamples]);
	return (
		<>
			{piiClassifiers.map((classifier) => (
				<Badge
					key={classifier}
					variant="warning"
					w="fit-content"
					sx={{ textTransform: 'none' }}
				>
					{classifier}
				</Badge>
			))}
		</>
	);
}
